export default "__VITE_ASSET__1ed2e8f2__"